import UdeskLocales from 'UdeskLocales';
import React, { FC, memo, useState } from 'react';
import { useRequest } from 'ahooks';
import { Button, Form, Input, message, Space, Spin } from 'udesk-ui';
import { FormWrapper, Wrapper } from './components';
import { getCcpassConfigs, putCcpassConfigs } from 'src/api/ccpassConfigs';
import { CcpassConfigFoundResponse } from 'src/api/types';

interface FormValues extends Omit<CcpassConfigFoundResponse, 'id'> {}

interface TempalteProps {}

const Tempalte: FC<TempalteProps> = memo((props) => {
    const locales = UdeskLocales['current'];

    const [form] = Form.useForm();

    const [initFormValues, setInitFormValues] = useState<FormValues>();

    const {
        run: refresh,
        loading: getLoading,
        data,
    } = useRequest(() => getCcpassConfigs({}), {
        onSuccess: (res) => {
            setInitFormValues({
                domain: res.data?.domain,
                email: res.data?.email,
                appid: res.data?.appid,
                secret: res.data?.secret,
            });
            form.resetFields();
        },
    });

    const { run: onFinish, loading: postLoading } = useRequest(
        (values: FormValues) => putCcpassConfigs({ ...values, id: data?.data?.id }),
        {
            manual: true,
            onSuccess: () => {
                message.success(
                    /* 授权成功 */ UdeskLocales['current'].pages.systemIntegration.zendesk
                        .components.ticket.index.authorizationSucceeded
                );
                refresh();
            },
        }
    );

    return (
        <Wrapper>
            <Spin spinning={getLoading || postLoading}>
                <FormWrapper>
                    <Form
                        form={form}
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 10 }}
                        initialValues={initFormValues}
                        onFinish={onFinish}
                        style={{ flex: 1 }}
                    >
                        <Form.Item name="domain" label={/* 域名 */UdeskLocales['current'].pages.systemIntegration.voiceRobot.index.domainName} rules={[{ required: true }]}>
                            <Input maxLength={200} />
                        </Form.Item>

                        <Form.Item name="email" label={/* 管理员邮箱 */UdeskLocales['current'].pages.systemIntegration.voiceRobot.index.administratorMailbox} rules={[{ required: true }]}>
                            <Input maxLength={200} />
                        </Form.Item>

                        <Form.Item name="appid" label={/* 租户appid */UdeskLocales['current'].pages.systemIntegration.voiceRobot.index.tenantAppid} rules={[{ required: true }]}>
                            <Input maxLength={200} />
                        </Form.Item>

                        <Form.Item name="secret" label={/* 租户secrect */UdeskLocales['current'].pages.systemIntegration.voiceRobot.index.tenantSecrect} rules={[{ required: true }]}>
                            <Input maxLength={200} />
                        </Form.Item>

                        <Form.Item wrapperCol={{ offset: 8 }}>
                            <Space>
                                <Button key="applyAuth" type="primary" htmlType="submit">
                                    {locales.pages.admin.systemIntegration.applyAuth}
                                </Button>
                            </Space>
                        </Form.Item>
                    </Form>
                </FormWrapper>
            </Spin>
        </Wrapper>
    );
});

export default Tempalte;
